<div class="user-assignments-container" *ngIf="isTranslationLoaded">  
  <details-section [title]="'reportingV2.ASSIGNMENT_LABEL' | transloco" [showDetails]="false">
    <div class="assignments-tabs">
      <qai-tabs (tabSelected)="onTabChange($event)">
        <ng-template qaiTab="practice" label="{{ 'reportingV2.PRACTICE_LABEL' | transloco }}" *ngIf="practiceAssignments.length > 0">
          <div class="tab-content">
            <app-practice-tab 
              [assignments]="practiceAssignments"
              [userAssignmentMetrics]="userAssignmentMetrics"
              [isLoading]="isLoading">
            </app-practice-tab>
          </div>
        </ng-template>

        <ng-template qaiTab="certification" label="{{ 'reportingV2.CERTIFICATION_LABEL' | transloco }}" *ngIf="certificationAssignments.length > 0">
          <div class="tab-content">
            <app-certification-tab 
              [assignments]="certificationAssignments"
              [assignmentMetrics]="userAssignmentMetrics"
              [isLoading]="isLoading">
            </app-certification-tab>
          </div>
        </ng-template>
      </qai-tabs>
    </div>
  </details-section>
</div>
